import React from "react";
import { getContextMenuOptions } from "./filemanager-utils";

const ContextMenu = ({ contextMenuPosition, selectedFiles, canPaste, onItemClicked, hasTarget, isSharedFolder }) => {
	const { perms } = hp.store;
	const options = getContextMenuOptions({ perms, hasTarget, isSharedFolder, canPaste, selectedFiles });

	return (
		<div className="context-menu" style={contextMenuPosition}>
			{options
				.filter(opt => opt.visible)
				.map(opt => (
					<React.Fragment key={opt.key}>
						<div
							className={`context-menu-option ${opt.disabled ? "disabled" : ""} ${opt.dividerAfter ? "border-bottom" : ""}`}
							onClick={(e) => !opt.disabled && onItemClicked(e, opt.key)}
						>
							<em className={opt.icon}></em>&nbsp;{opt.label}
						</div>
					</React.Fragment>
				))}
		</div>
	);
};

export default ContextMenu;
